import React, {Component} from 'react';
import {connect} from 'react-redux';

import {
    Row,
} from 'reactstrap';

import ReduxModalWrapper from "../../../components/display/Modals/ReduxModalWrapper";
import FlowButton from "../../../components/flow/PolyFlow/FlowButton";
import CreditForm from "../../../components/credit/CreditForm";

class GuarantorCreditFrame extends Component {
    render() {
        const {confirmed} = this.props;

        return (
            <div className="mt-4">
                <Row>
                    {
                        confirmed ? (
                            <h3>Identity verified and credit check completed</h3>
                        ) : (
                            <h3>Time to verify your identity and check your credit</h3>
                        )
                    }
                </Row>
                <hr/>
                {
                    confirmed ? (
                        <div>
                            <p>Thank you for verifiying your identity. A credit check has been completed -- you're all good to go!</p>
                            <div className="center">
                                <FlowButton id="guarantorFlow" className="mt-4" onClick="inc" color="success" outline>Finish Up</FlowButton>
                            </div>
                        </div>
                    ) : (
                        <CreditForm guarantor tenantId={this.props.tenant_id} tenantKey={this.props.tenant_key}/>
                    )
                }


                <ReduxModalWrapper id="tu_exam_modal"/>

            </div>
        );
    }
}

const mapStateToProps = (state) => {

    return {
        confirmed: state.guarantor.verification_status === 'Verified',
    };
};

export default connect(mapStateToProps)(GuarantorCreditFrame);



// WEBPACK FOOTER //
// ./src/containers/guarantor/frames/GuarantorCreditFrame.js